export default {
  chat_send: "發送",
  chat_send_empty: "不能傳送空白訊息",
  chat_hello: "您好！有什麼問題我可以幫助到您。",
  chat_received: "您的回饋我們已經收到，會盡快為您處理。",
  chat_cancel: "取消",
  text_completed: "已完成",
  text_undone: "未完成",
  "text_contact_us": "聯絡我們",
  "my_setting_phone_cust": "電話客服",
  "my_setting_zalo_cust": "聯絡Zalo客服",
  "my_setting_facebook_cust": "聯絡Facebook客服",
  "my_setting_whatsapp_cust": "聯絡WhatsApp客服",
  "text_click": "點擊",
  "text_copy": "複製",
  "bank_copy_suc": "複製成功",
}